import { Link } from "react-router-dom";
import type { ReactNode } from "react";

import { buttonVariants } from "@/components/ui/button";
import type { PreferredContact } from "@/lib/wizard-schemas";

function safeHref(raw: string): string | null {
  const trimmed = raw.trim();
  if (!trimmed) return null;
  try {
    const proto = new URL(trimmed).protocol;
    if (proto === "http:" || proto === "https:") return trimmed;
    return null;
  } catch {
    return null;
  }
}

export function listOrDash(list: string[]): ReactNode {
  if (!list || list.length === 0) {
    return <span className="text-muted-foreground">—</span>;
  }
  return (
    <ul className="list-disc space-y-0.5 pl-4">
      {list.map((v, i) => (
        <li key={`${v}-${i}`} className="break-words">
          {v}
        </li>
      ))}
    </ul>
  );
}

export function linksOrDash(list: string[]): ReactNode {
  if (!list || list.length === 0) {
    return <span className="text-muted-foreground">—</span>;
  }
  return (
    <ul className="space-y-0.5">
      {list.map((v, i) => {
        const href = safeHref(v);
        return (
          <li key={`${v}-${i}`} className="break-all">
            {href ? (
              <Link
                to={href}
                target="_blank"
                rel="noopener noreferrer nofollow"
                className={buttonVariants({
                  variant: "link",
                  size: "sm",
                  className: "h-auto p-0",
                })}
              >
                {v}
              </Link>
            ) : (
              <span className="text-muted-foreground">{v}</span>
            )}
          </li>
        );
      })}
    </ul>
  );
}

export function preferredLabel(v: PreferredContact | string): string {
  if (v === "whatsapp") return "WhatsApp";
  if (v === "either") return "Email or WhatsApp";
  return "Email";
}

export function stringOrDash(v: string | null | undefined): ReactNode {
  return v && v.length > 0 ? v : <span className="text-muted-foreground">—</span>;
}
